import { FC } from 'react';

import { Flex, Layer, VSpacing } from '@hh.ru/magritte-ui';

import { CampaignsControls } from 'components/CampaignsDashboard/components/CampaignsControls';
import { CampaignCard } from 'components/CampaignsDashboard/components/CampaignsTable/components/CampaignCard/CampaignCard';
import { SelectAllCheckbox } from 'components/CampaignsDashboard/components/CampaignsTable/components/SelectAllCheckbox';

import { useSelector } from 'store/utils';

import styles from 'components/CampaignsDashboard/components/CampaignsTable/CampaignsMobileList.module.less';

export const CampaignsMobileList: FC = () => {
    const campaigns = useSelector((state) => state.campaignsDashboard.campaigns);

    return (
        <>
            <Layer layer="content">
                <div className={styles.stickyControls} data-qa="campaigns-mobile-sticky-controls">
                    <CampaignsControls />
                    {campaigns.size > 0 && <VSpacing default={24} />}
                </div>
            </Layer>
            {campaigns.size > 0 && (
                <Flex direction="column" gap={16}>
                    <SelectAllCheckbox isMobile />
                    <Flex direction="column" gap={12} width="100%">
                        {[...campaigns.values()].map((campaign) => (
                            <CampaignCard key={campaign.id} campaign={campaign} />
                        ))}
                    </Flex>
                </Flex>
            )}
        </>
    );
};
